import React, {useEffect} from "react";
import Link from "../utils/link";
import {Darling, Group, Terrace} from "./icons";
import {Instagram, Facebook, Linkedin, Tiktok} from "./icons";
import {gsap} from "gsap";

const Footer = () => {

    useEffect(() => {
        const logoAnimation = gsap.timeline({repeat: -1, repeatDelay: 5});

        logoAnimation
            .to('.logo--close', {
                visibility: 'visible',
                opacity: 1,
                duration: 0.2,
                ease: 'power1.inOut',
            })
            .to('.logo--close', {
                visibility: 'hidden',
                opacity: 0,
                duration: 0.2,
                ease: 'power1.inOut'
            });
    }, []);

    return (
        <div className="footer">
            <div className='footer__inner'>
                <div className='footer__top'>
                    <div className="logo">
                        <div className="logo--word">
                            <Terrace/>
                        </div>
                    </div>
                </div>

                <div className='footer__middle'>
                    <div className='footer__time'>
                        <ul>
                            <li>Mon to Fri <br/> 8AM – 4PM</li>
                            <li>Sat to Sun <br/> 8AM – 5PM</li>
                        </ul>
                    </div>

                    <div className='footer__location'>
                        <Link target='_blank' to='https://maps.app.goo.gl/j5LFLMA7r51i7z1Z8'>Royal Botanic Gardens Melbourne</Link>
                        <Link target='_blank' to='https://maps.app.goo.gl/j5LFLMA7r51i7z1Z8'>Enter via Bridge Gate<br />Alexandra Avenue & Anderson Street</Link>
                        <Link to='mailto:info@theterrace.melbourne'>info@theterrace.melbourne</Link>
                        <Link to='tel:+61390876836'>03 9087 6836</Link>
                    </div>

                    <div className='footer__nav'>
                        <div className='footer__social'>
                            <h3>Socials</h3>
                            <ul>
                                <li><Link to='https://www.instagram.com/theterracebotanicgardens/'><Instagram/></Link></li>
                                <li><Link to='https://www.facebook.com/p/The-Terrace-Melbourne-100085486673279/'><Facebook/></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className='footer__bottom'>
                    <div className='footer__bottom--logo'>
                        <Link target='_blank' to='https://darlinggroup.com.au/'>
                            <Darling/>
                            <Group/>
                        </Link>
                    </div>

                    <div className='footer__credit'>
                        <div className='footer__col'>
                            <p>© 2026 Darling Group. All rights reserved.</p>
                        </div>

                        <div className='footer__res'>
                            <ul>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/cheri/'>Cheri</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/higher-ground/'>Higher Ground</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/terrace/'>Terrace</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/top-paddock/'>Top paddock</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/kettle-black/'>Kettle Black</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/token/'>Token</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/darling/'>Darling</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/dundas-faussett/'>Dundas & Faussett</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/bambu/'>Bambu</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/stringers/'>Stringers</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/the-observatory/'>The Observatory</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;